var ur = window.location.href;
if (ur.includes('/product') && jQuery('.sanitred-form-container').length == 0) {
  jQuery(document).ready(function () {
    if (window.innerWidth < 981) {
      jQuery('.product-single__meta').eq(0).append(jQuery('.product-block.product-block.product-block--description').eq(0))
    }

    function initDTB() {
      Element.prototype.appendBefore = function (element) {
        element.parentNode.insertBefore(this, element);
      };
      var globalctr = 1;
      var dCtr = 1;
      jQuery(".variant-wrapper--dropdown .variant-input-wrap").each(function (i, e) { // select parent
        jQuery(this).addClass("d" + globalctr);
        jQuery(this).addClass('sanitred-form-container');
        if (jQuery(".d" + globalctr + " select option").length > 0) {
          jQuery("<div ></div>")
            .attr('id', "r" + globalctr)
            .attr('class', "r")
            .insertAfter(this);

          var select = jQuery(".d" + globalctr + " select");
          var option1 = jQuery(".d" + globalctr + " select option").eq(1).val();
          var selected = select.prop("selectedIndex");

          jQuery(".d" + globalctr + " select option").each(function (i, e) {
            jQuery("<input type='radio'/><span></span>")
              .attr("value", jQuery(this).val())
              .attr("checked", i == selected)
              .attr("disabled", jQuery(this).is(':disabled'))
              .attr("data-id", globalctr)
              .html(`<span class="abz-vimag" ${e.getAttribute('name') == 'Size' ? 'style="display: none"' : ''}><img src="${e.dataset.image}"/></span>` + '<span class="abz-vcontent"><p>' + jQuery(this).html() + '</p>' + '<p class="abz-stock-status">' + jQuery(this).data('stock-status') + '</p></span>')
              .click(function () {

                if (e.hasAttribute('disabled')) return;
                var radioBut = jQuery("#r" + jQuery(this).attr("data-id") + " input");
                for (var i = 0; i < radioBut.length; i++) {
                  radioBut[i].checked = false;

                }


                jQuery(this).prop('checked', true);
                jQuery(".d" + jQuery(this).attr("data-id") + " select").focus();
                jQuery(".d" + jQuery(this).attr("data-id") + " select").val(jQuery(this).val());
                let selectClass = ".d" + jQuery(this).attr("data-id") + " select";
                document.querySelector(selectClass).dispatchEvent(new Event('change'));
                // jQuery(".d"+ jQuery(this).attr("data-id")+" select").trigger("change");


              })
              .appendTo("#r" + globalctr).parent();

          });

          jQuery("#r" + globalctr + " input").each(function (i, e) {
            jQuery(this).next('span').addBack().wrapAll('<label style="display:inline-block!important;"></label>');


          });

          globalctr++;
        }
        else {
          jQuery(this).attr('id', "");
          jQuery(this).removeClass('sanitred-form-container');
        }
      });
    };
    initDTB();

    Element.prototype.appendAfter = function (element) {
      element.parentNode.insertBefore(this, element.nextSibling);
    };
    var imgSrcs = ['https://cdn.shopify.com/s/files/1/0617/1649/6441/files/money-back.png?v=1677208192',
      'https://cdn.shopify.com/s/files/1/0617/1649/6441/files/shipping.png?v=1677208192',
      'https://cdn.shopify.com/s/files/1/0617/1649/6441/files/fda-approved.png?v=1677208192'];
    var badgeTexts = ["100% Money Back Guarantee",
      "Free Shipping to USA",
      "Made in FDA Inspected Facility"];
    var container = document.createElement('div');
    container.className = 'simple-badges-outer-container';
    var imgContainer = document.createElement('div');
    imgContainer.innerHTML = '';
    imgContainer.className = 'simple-img-container';
    var y = document.querySelectorAll('.product-single__meta')[0];
    if (document.getElementsByClassName('simple-img-container').length == 0) {
      y.appendChild(container)
      container.appendChild(imgContainer);

    }

    for (var i = 0; i < imgSrcs.length; i++) {

      var img = document.createElement('div');
      img.innerHTML = '<div class="simple-badge-container"><img src="' + imgSrcs[i] + '"><span class="badge' + i + '">' + badgeTexts[i] + '</span></div>';
      imgContainer.appendChild(img);
      img.className = "simple-badges-container";


    }
    jQuery('.product-block.product-block--sales-point').eq(0).before(jQuery('.simple-badges-outer-container').eq(0));
  });
}




if (ur.includes('/product')) {
  jQuery(document).ready(function () {

    var btnClass = "button.btn.btn--full.add-to-cart";
    var selectorClass = ".variant-wrapper";

    Element.prototype.appendAfterThis = function (element) {
      element.parentNode.insertBefore(this, element.nextSibling);
    };
    var sticky = document.createElement('div');
    sticky.innerHTML = '<div class="simple-st-container" id="simple-st-containerID"> <div class="simple-st-container__outer"><div class="simple-product-cont"><div class="simple-product-name"><p></p></div></div> <div class="simple-st-container__inner"> <div class="simple-product-price"></div><div class="simple-select-container"> <div class="simple-st-select" id="st-select0"> <span>Color</span> <select> <option></option> </select> </div><div class="simple-st-select" id="st-select1"> <span>Type</span> <select> <option></option> </select> </div><div class="simple-st-select" id="st-select2"> <span>Type</span> <select> <option></option> </select> </div></div><div class="simple-st-item_column__button"><a class="simple-st-item__button" rel="nofollow">Add to Cart <span class="xoo-cp-icon-spinner xoo-cp-added"></span></a></div></div></div></div>';
    var y = document.getElementsByTagName('body');
    if (document.getElementsByClassName('simple-st-container').length == 0) {
      y[0].appendChild(sticky);


      jQuery('.simple-product-name p').html(jQuery('h1.h2.product-single__title').eq(0).text());
      jQuery('.simple-product-name').eq(0).append(jQuery('.stamped-main-badge').eq(0).clone())



      setInterval(function () {


        jQuery('.simple-product-price').eq(0).html(jQuery('.product-block.product-block--price').eq(0).html())

      }, 1000);


      function populateOptions(select, labels, isDrop) {
        if (isDrop) {
          var selected = labels.eq(0).find('select').prop('selectedIndex');
          labels = labels.eq(0).find('option');

        }
        else {

          labels = labels.eq(0).find('.swatch-element .text');
        }

        for (var i = 0; i < labels.length; i++) {
          var option = document.createElement('OPTION');

          var t = document.createTextNode(labels.eq(i).html());
          option.appendChild(t);
          option.id = i;
          select.appendChild(option);

          if (i == 0) {
            select.removeChild(select.firstElementChild);


          }

          if (labels.eq(i).closest('.swatch-element').find('input').attr('checked')) {
            selected = i
          }

        }

        select.selectedIndex = selected;
      }

      jQuery('.simple-st-item__button').click(function () {

        if (!jQuery('.simple-st-item__button').hasClass("simple-st-disabled")) {

          document.querySelectorAll('button.btn.btn--full.add-to-cart')[0].click();
        }

      });


      if (jQuery('[data-type="dropdown"]').eq(0).length >= 1) {

        jQuery('.simple-st-select span').eq(0).html(jQuery(selectorClass).eq(0).find('label.variant__label').html());
        jQuery('#st-select0').attr('style', 'display: flex');
        populateOptions(document.getElementById('st-select0').getElementsByTagName('select')[0], jQuery('[data-type="dropdown"]').eq(0), 1);
      }


      if (jQuery('[name="Supply"]').eq(0).length >= 1) {

        jQuery('.simple-st-select span').eq(1).html('Type');
        jQuery('#st-select1').attr('style', 'display: flex');
        populateOptions(document.getElementById('st-select1').getElementsByTagName('select')[0], jQuery('[name="Supply"]').eq(0).parent().parent(), 0);
      }



    };

    function checkIfDisabled() {
      setTimeout(function () {
        var elem = jQuery(btnClass).eq(0);
        jQuery('.simple-st-item__button').html(elem.text());
        console.log(elem.html())
        if (elem.text().toUpperCase().trim() != 'ADD TO CART') {
          jQuery('.simple-st-item__button').html(elem.text());
          jQuery('.simple-st-item__button').addClass('simple-st-disabled');
        } else {
          jQuery('.simple-st-item__button').removeClass('simple-st-disabled');
        }
      }, 100);
    }
    jQuery('#st-select0 > select').change(function () {
      checkIfDisabled();
      var i = jQuery(this).find(":selected").attr('id');
      document.querySelector('[data-type="dropdown"] select').selectedIndex = i;
      document.querySelector('[data-type="dropdown"] select').dispatchEvent(new Event('change'));

    });

    jQuery('#st-select1 > select').change(function () {
      checkIfDisabled();
      var i = jQuery(this).find(":selected").attr('id');
      jQuery('.swatch-element input').eq(i).click();

    });

    jQuery('[data-type="dropdown"] select').change(function () {
      checkIfDisabled();
      jQuery('#st-select0 > select').val(jQuery(this).val());

    });
    jQuery('.swatch-element input').click(function () {
      checkIfDisabled();
      jQuery('#st-select1 > select').val(jQuery(this).parent().find('.text').html());
    });




    checkIfDisabled();

    function isVisible(elem) {
      var elementTop = elem.offset().top;
      var elementBottom = elementTop + elem.outerHeight();
      var viewportTop = jQuery(window).scrollTop();
      var viewportBottom = viewportTop + jQuery(window).height();
      return elementBottom > viewportTop && elementTop < viewportBottom;
    };

    var mc = window.matchMedia("(min-width: 767px)");


    var elem = document.getElementById("simple-st-containerID");
    function slideShow() {
      jQuery('body').addClass('simple-sticky');
    }

    function slideHide() {
      jQuery('body').removeClass('simple-sticky');
    }

    jQuery(document).scroll(function () {
      var y = jQuery(this).scrollTop();
      if (y > jQuery(btnClass).eq(0).offset().top) {
        slideShow();

      } else {

        slideHide();

      }
    });
  });
}
